/**
 * 已翻译单词高亮业务逻辑钩子
 * 提供单词高亮和交互的核心业务逻辑
 */
import { useState, useCallback, useMemo, useRef } from 'react';
import { generateTextHighlightedSegments, convertTranslationToTooltipData } from '@readsavor/utils';
// convertTranslationToTooltipData is now imported from @readsavor/utils
/**
 * 已翻译单词高亮业务逻辑钩子
 */
export function useTranslatedWordHighlighter(params) {
    const { paragraph, paragraphTranslations, isLoading: isLoadingFromProps } = params;
    const renderCountRef = useRef(0);
    renderCountRef.current += 1;
    const [hoveredWord, setHoveredWord] = useState(null);
    // Determine loading state: true if prop says so, or if essential paragraph data is missing.
    const loading = useMemo(() => {
        if (isLoadingFromProps !== undefined) {
            return isLoadingFromProps;
        }
        return !paragraph || !paragraph.content;
    }, [isLoadingFromProps, paragraph]);
    const segments = useMemo(() => {
        if (!paragraph || !paragraph.content) {
            // Return a single unhighlighted segment if paragraph content is not available
            return [{ id: '0', text: paragraph?.content || '', highlighted: false, data: undefined }];
        }
        // paragraphTranslations are already filtered for the current paragraph by the caller
        const relevantWords = paragraphTranslations;
        if (!relevantWords || relevantWords.length === 0) {
            return [{ id: '0', text: paragraph.content, highlighted: false, data: undefined }];
        }
        const rawHighlightedSegments = generateTextHighlightedSegments(paragraph.content, relevantWords // Use the passed, pre-filtered translations
        );
        const uiSegments = rawHighlightedSegments.map((segment, index) => ({
            id: `${paragraph.id || paragraph.index}-${index}`,
            text: segment.text,
            highlighted: segment.isTranslated,
            data: convertTranslationToTooltipData(segment.translationData),
        }));
        return uiSegments;
    }, [paragraph, paragraphTranslations]);
    const handleHighlightHover = useCallback((_id, word, _element) => {
        setHoveredWord(word);
    }, []);
    const handleHighlightLeave = useCallback(() => {
        setHoveredWord(null);
    }, []);
    // Logging the returned state and functions
    return {
        segments,
        hoveredWord,
        loading,
        handleHighlightHover,
        handleHighlightLeave,
    };
}
//# sourceMappingURL=useTranslatedWordHighlighter.js.map